module.exports = __webpack_public_path__ + "img/EnergyExpert1.82bce883.png";